import React, { useEffect, useMemo, useState } from 'react';
import CustomCard, { CustomGridLayout } from '../../shared/Cards/CustomCard';
import { CustomCalenderInput, CustomDropDown, CustomInput, CustomInputMask, CustomInputNumber, CustomTextArea } from '../../shared/Input/AllInputs';
import { LeadPriorityOptions, genderOptions } from '../../utils/dropdownConstants';
import CustomImageInput from '../../shared/Input/CustomImageInput';
import { useDispatch, useSelector } from 'react-redux';
import PrimaryButton, { CustomButtonGroup, LightButton } from '../../shared/Button/CustomButton';
import debounce from 'lodash.debounce';
import { showFormErrors } from '../../utils/commonFunctions';
import { useHistory } from 'react-router-dom';
import formValidation, { requiredFieldsValidation } from '../../utils/validations';
import usePlacesAutocomplete from './usePlacesAutoComplete';
import api from '../../services/api';
import endPoints from '../../services/endPoints';
import { addMembers, getMembers } from '../../redux/actions/MembersPortal/memberPortalActions';
import { getCampaigns } from '../../redux/actions/Settings/MembershipSetup/campaignsAction';
import { getEmployees } from '../../redux/actions/Settings/Employee/employeesAction';
import { getdefaultSetting } from '../../redux/actions/Settings/Business/defaultSettingActions';

const AddMembers = () => {
    const [data, setData] = useState({
        createType: 'PROSPECT',
        barCode: 0,
        note: '',
        firstName: '',
        lastName: '',
        MI: '',
        gender: 'MALE',
        dob: '',
        image: [],
        govtId: '',
        primaryPhone: '',
        mobilePhone: '',
        workNumber: '',
        address: '',
        latitude: 30.72,
        longitude: 76.64,
        leadPriority: 'NONE',
        salesPerson: '',
        campaign: '',
        issuedOn: '',
        tourOn: '',
        startOn: '',
        beginOn: '',

        uniqueBarCode: false,

        requiredFieldsMap: {},
    });
    const dispatch = useDispatch();
    const history = useHistory();

    const mapRequiredFields = (fieldsArray) => {
        return fieldsArray.reduce((acc, fieldName) => {
            acc[fieldName] = true;
            return acc;
        }, {});
    };

    console.log('data', data);

    useEffect(() => {
        dispatch(getEmployees());
        dispatch(getCampaigns());
        dispatch(
            getdefaultSetting((data) => {
                let _requiredFields = data.fastAddRequiredFields || [];
                setData((prev) => ({
                    ...prev,
                    requiredFieldsMap: mapRequiredFields(_requiredFields || []),
                }));
            }),
        );
    }, [dispatch]);

    const { employeesDropdown } = useSelector((state) => state.settings.employee);
    const { campaignDropdown } = useSelector((state) => state.settings.members);
    const loading = useSelector((state) => state.loader.isLoading);

    const handleChange = ({ name, value }) => {
        let formErrors = { ...data?.formErrors };
        const requiredFields = Object.keys(data?.requiredFieldsMap);

        // Run validation for each field dynamically
        Object.keys(data).forEach((key) => {
            formErrors = requiredFieldsValidation(key, data[key], { ...data, formErrors }, requiredFields);
        });

        if (name === 'barCode') {
            setData((prev) => ({ ...prev, [name]: value, formErrors }));
            if (value) {
                debouncedChangeHandler(value);
            }
        } else {
            setData((prev) => ({ ...prev, [name]: value, formErrors }));
        }
    };

    const changeHandler = async (val) => {
        const res = await api('post', endPoints.MEMBER_BARCODE, { barCode: val });
        if (res.success) {
            setData((prev) => ({ ...prev, uniqueBarCode: false }));
        } else {
            setData((prev) => ({ ...prev, uniqueBarCode: true }));
        }
    };

    useEffect(() => {
        const formErrors = formValidation('barCode', data.uniqueBarCode, data);
        if (data?.uniqueBarCode) {
            formErrors['barCode'] = 'BarCode should be unique!';
        } else {
            formErrors['barCode'] = '';
        }
        setData((prev) => ({ ...prev, formErrors }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data.uniqueBarCode]);

    const debouncedChangeHandler = useMemo(
        () =>
            debounce((val) => {
                changeHandler(val);
            }, 1000),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    );

    const handleSave = () => {
        let formErrors = { ...data.formErrors };
        const requiredFields = Object.keys(data.requiredFieldsMap);

        console.log('requiredFields', requiredFields);

        // Validate all fields using requiredFieldsValidation
        Object.keys(data).forEach((key) => {
            formErrors = requiredFieldsValidation(key, data[key], { ...data, formErrors }, requiredFields);
        });

        // Update formErrors state
        setData((prev) => ({ ...prev, formErrors }));

        // Check if there are any errors
        const hasErrors = Object.values(formErrors).some((errMsg) => errMsg);

        if (!hasErrors) {
            dispatch(
                addMembers(data, () => {
                    history.goBack();
                    dispatch(getMembers());
                }),
            );
        }
    };

    const { renderAutocomplete } = usePlacesAutocomplete(data, setData);

    //  check for strict Boolean checking
    const isRequired = (name) => !!data.requiredFieldsMap?.[name];

    return (
        <>
            <h3>Fast Add</h3>
            <CustomCard col="12" title="Membership">
                <CustomGridLayout>
                    <div className="col-2">
                        <CustomImageInput name="image" data={data} onFilesChange={handleChange} required={isRequired('image')} editable={true} />
                    </div>
                    <CustomGridLayout extraClass="col-10">
                        <CustomInput col="4" name="barCode" data={data} onChange={handleChange} required={isRequired('barCode')} />
                        <CustomTextArea name="note" data={data} onChange={handleChange} required={isRequired('note')} />
                    </CustomGridLayout>
                </CustomGridLayout>
            </CustomCard>
            <CustomCard col="col-12" title="Personal">
                <CustomGridLayout>
                    <CustomInput name="firstName" data={data} onChange={handleChange} required={isRequired('firstName')} col="3" />
                    <CustomInput name="MI" data={data} onChange={handleChange} col="2" required={isRequired('MI')} />
                    <CustomInput name="lastName" data={data} onChange={handleChange} required={isRequired('lastName')} col="3" />
                    <CustomDropDown name="gender" data={data} onChange={handleChange} options={genderOptions} required={isRequired('gender')} />
                    <CustomCalenderInput
                        label="Date Of Birth"
                        name="dob"
                        data={data}
                        onChange={handleChange}
                        maxDate={new Date()}
                        required={isRequired('dob')}
                    />
                    <CustomInput name="govtId" data={data} onChange={handleChange} required={isRequired('govtId')} />
                    <CustomInputMask name="primaryPhone" mask="(999) 999-9999" data={data} onChange={handleChange} required={isRequired('primaryPhone')} />
                    <CustomInputMask name="mobilePhone" mask="(999) 999-9999" data={data} onChange={handleChange} required={isRequired('mobilePhone')} />
                    <CustomInputMask name="workNumber" mask="(999) 999-9999" data={data} onChange={handleChange} required={isRequired('workNumber')} />
                    <CustomInput name="workExt" data={data} onChange={handleChange} col="4" required={isRequired('workExt')} />
                </CustomGridLayout>
            </CustomCard>
            <CustomCard col="12" title="Address">
                <CustomGridLayout>
                    <div className="md:col-12">
                        <label className="text-sm font-semibold">Address</label>
                        <span className="text-red-500">{isRequired('address') && '*'} </span>
                        {renderAutocomplete()}
                    </div>
                </CustomGridLayout>
            </CustomCard>
            <CustomCard col="12" title="Sale">
                <CustomGridLayout>
                    <CustomDropDown
                        name="leadPriority"
                        data={data}
                        onChange={handleChange}
                        options={LeadPriorityOptions}
                        required={isRequired('leadPriority')}
                    />
                    <CustomDropDown
                        name="salesPerson"
                        data={data}
                        onChange={handleChange}
                        required={isRequired('salesPerson')}
                        options={employeesDropdown}
                        optionLabel="name"
                    />
                    <CustomDropDown
                        name="campaign"
                        data={data}
                        onChange={handleChange}
                        required={isRequired('campaign')}
                        options={campaignDropdown}
                        optionLabel="name"
                    />
                </CustomGridLayout>
            </CustomCard>
            <CustomCard col="12" title="Date">
                <CustomGridLayout>
                    <CustomCalenderInput name="issuedOn" data={data} onChange={handleChange} required={isRequired('issuedOn')} />
                    <CustomCalenderInput name="tourOn" data={data} onChange={handleChange} required={isRequired('tourOn')} />
                    <CustomCalenderInput name="firstVisit" data={data} onChange={handleChange} required={isRequired('firstVisit')} />
                    <CustomCalenderInput name="beginOn" required={isRequired('beginOn')} data={data} onChange={handleChange} maxDate={data.expiration} />
                </CustomGridLayout>
            </CustomCard>
            <CustomButtonGroup>
                <PrimaryButton label="Save" className="mx-2" onClick={handleSave} loading={loading} />
                <LightButton label="Cancel" onClick={() => history.goBack()} />
            </CustomButtonGroup>
        </>
    );
};

export default AddMembers;
